module.exports = __webpack_public_path__ + "components/country-flag/static/md-5e4d921749b4bd1e97f7941583a29c85.svg";